import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { ErrorAlertType, IErrorAlertObject } from "../../../ErrorAlert/redux/Types";
import { ErrorAlertSlice } from "../../../ErrorAlert/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import Delete from "~icons/ic/outline-delete-outline";
import "./Style.scss";

interface IDeleteScheduleProps {
  onDelete: () => Promise<void>;
  showAlert: boolean;
  scheduleName: string;
  isDeleteEnabled: boolean;
}

/**
 * Component for rendering the schedule table
 * @param props properties
 * @returns Component JSX
 */

export const ScheduleRemoveView: React.FC<IDeleteScheduleProps> = (props: IDeleteScheduleProps): JSX.Element => {
  const { onDelete, scheduleName, isDeleteEnabled } = props;
  const { t: translate } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const dispatch = useDispatch();
  const onClick = (): void => {
    setShowAlert(!showAlert);
    const errorContent: IErrorAlertObject = {
      title: translate("Scheduling.RemoveSchedule.Title"),
      message: [
        translate("Scheduling.RemoveSchedule.FirstMessage"),
        scheduleName + "?",
        translate("Scheduling.RemoveSchedule.SecondMessage")
      ],
      actionButtonText: translate("Button.Delete"),
      cancelButtonText: translate("Button.Cancel"),
      actionClick: () => onDelete(),
      buttonVarient: ButtonVariantType.Danger,
      type: ErrorAlertType.WARNING,
    };
    dispatch(ErrorAlertSlice.actions.createErrorAlert(errorContent));
  };

  return (
    <>
      {isDeleteEnabled &&
        <div
          data-testid="ebt-remove-schedule"
          onClick={onClick}
          className="ebt-remove"
        >
          <Delete
            title="delete"
          />
          <span className="ebt-remove__icon">
            {translate("Scheduling.Buttons.Delete")}
          </span>
        </div>
      }
    </>
  );
};
